import { render, staticRenderFns } from "./CampaignAnnouncement.vue?vue&type=template&id=0d617fb6&scoped=true"
import script from "./CampaignAnnouncement.vue?vue&type=script&lang=js"
export * from "./CampaignAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./CampaignAnnouncement.vue?vue&type=style&index=0&id=0d617fb6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d617fb6",
  null
  
)

export default component.exports